import Grid from '@mui/material/Grid'
import CheckInList from './CheckInList'
import { AllUpcomingEventList } from 'components/molecules/myTeam/EventList'
import { Typography } from '@mui/material'
import AssessmentsList from '../assessments/AssessmentsList'
import { useTranslation } from 'react-i18next'

const ActivityLists = () => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={12} width={'100%'}>
      <CheckInList />
      <AllUpcomingEventList
        pageLimit={2}
        titleComponent={
          <Typography>{t('contact.upcomingMeetings')}</Typography>
        }
      />
      <AssessmentsList
        updatedStyle={true}
        displayCount={2}
      />
    </Grid>
  )
}

export default ActivityLists
